














































































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { doublePrevention } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ImportDialogData extends Vue {
  private visible = false;
  private dataList: any = [];

  private importTableData: any = {
    failList: [],
    succeedList: [],
  };
  private submitLoading: any = false;
  private listStyle: any = true;

  private mounted() {}
  switchTableStyle(flag: any) {
    this.listStyle = flag;
  }

  private async showDialog(data: any) {
    this.importTableData = data;
    this.visible = true;
  }
  objectSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    let tableData: any = [];
    let columnSpan: any = 0;
    if (this.listStyle) {
      tableData = this.importTableData.succeedList;
      columnSpan = 14;
    } else {
      tableData = this.importTableData.failList;
      columnSpan = 15;
    }
    if (columnIndex < columnSpan) {
      const _row = this.flitterData(tableData).one[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col,
      };
    }
    if (columnIndex === columnSpan) {
      const _row = this.flitterData1(tableData).one[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  flitterData(arr: any) {
    const spanOneArr: any = [];
    let concatOne: any = 0;
    arr.forEach((item: any, index: any) => {
      if (index === 0) {
        spanOneArr.push(1);
      } else {
        //name 修改
        if (item.id && item.id === arr[index - 1].id) {
          //第一列需合并相同内容的判断条件
          spanOneArr[concatOne] += 1;
          spanOneArr.push(0);
        } else {
          spanOneArr.push(1);
          concatOne = index;
        }
      }
    });
    return {
      one: spanOneArr,
    };
  }
  flitterData1(arr: any) {
    const spanOneArr: any = [];
    let concatOne: any = 0;
    arr.forEach((item: any, index: any) => {
      if (index === 0) {
        spanOneArr.push(1);
      } else {
        //name 修改
        if (item.id && item.id === arr[index - 1].id && item.measureSource === arr[index - 1].measureSource) {
          //第一列需合并相同内容的判断条件
          spanOneArr[concatOne] += 1;
          spanOneArr.push(0);
        } else {
          spanOneArr.push(1);
          concatOne = index;
        }
      }
    });
    return {
      one: spanOneArr,
    };
  }
  private exportBtn() {
    if (!this.importTableData.waitSaveList || !this.importTableData.waitSaveList.length) {
      this.$message.warning('暂无可导入的数据！');
      return;
    }
    this.submitLoading = true;
    doublePrevention.importRiskControlInventoryDataSave(this.importTableData.waitSaveList).then((res: any) => {
      if (res.code == 200) {
        this.$message.success('导入成功！');
        this.submitLoading = false;
        this.hideDialog();
      } else {
        this.$message.warning(res.msg);
        this.submitLoading = false;
      }
    });
  }

  private hideDialog() {
    this.visible = false;
    this.$emit('importResponse');
  }
}
